import React from 'react';
import { HomePageLayout } from '../../components/Layout/HomePageLayout';

const Index = (props) => <HomePageLayout {...props} />;

export default Index;
